import "./CTA.css";

function CTA(){

return(

<section className="cta">

<div className="container">

<div className="cta-box">

<h2>

Let's Build Your Next Project

</h2>

<p>

Need a Website, Software or Business Automation?
Let's discuss your idea today.

</p>

<a

href="https://wa.me/917722000088"

className="btn btn-light btn-lg"

>

Chat on WhatsApp

</a>

</div>

</div>

</section>

)

}

export default CTA;